module.exports = __webpack_public_path__ + "static/img/banner-2-right.c3b2e1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/banner-2-right.png
// module id = reka
// module chunks = 1